module.exports = __webpack_public_path__ + "static/MyResume-87929054180a0073fb40073728082660.pdf";